export const isDateTimeComplete = (selectedDateTimeObj: {
  [key: string]: string | number | undefined;
}): boolean => {
  return Object.values(selectedDateTimeObj).every(
    (value) => value !== undefined && value !== null && value !== '',
  );
};
